import {createSlice} from '@reduxjs/toolkit';
import type {Draft} from '@reduxjs/toolkit';
import {
    buildGeneralResetState,
    buildGeneralSetState,
    buildGeneralToggleState,
} from './general';
import {Cursor, empty, Ki, zeros, TNode} from 'ghostban';
import {Mode} from '../types';

type BoardState = {
    mode: Mode;
    currentNode: TNode | undefined;
    currentNodeId?: string;
    root: TNode | undefined;
    cursor: Cursor;
    zoom: boolean;
    turn: Ki;
    update: number;
    reset: number;
    sgf: string | undefined;
    mat: number[][];
    markup: string[][];
    visibleAreaMat: number[][];
    currentMarkupText: string;
    compressedPath: string;
    path: string;
    activeBranchIndexes: {[key: string]: number};
    highlights: string[];
};

const boardInitialState: BoardState = {
    mode: Mode.Stone,
    cursor: Cursor.None,
    turn: Ki.Empty,
    sgf: undefined,
    zoom: false,
    currentNodeId: undefined,
    // A counter to force re-rendering of the board
    update: 0,
    // A counter to force reset board
    reset: 0,
    // TODO: root and currentNode is not a serialized object, it may casuse
    root: undefined,
    currentNode: undefined,
    mat: zeros([19, 19]),
    markup: empty([19, 19]),
    visibleAreaMat: zeros([19, 19]),
    compressedPath: '',
    path: '',
    currentMarkupText: '',
    activeBranchIndexes: {},
    highlights: [''],
};

export const boardSlice = createSlice({
    name: 'board',
    initialState: boardInitialState,
    reducers: {
        setMode: buildGeneralSetState('mode'),
        setCursor: buildGeneralSetState('cursor'),
        setTurn: buildGeneralSetState('turn'),
        setZoom: buildGeneralSetState('zoom'),
        toggleZoom: buildGeneralToggleState('zoom'),
        setCurrentNodeId: buildGeneralSetState('currentNodeId'),
        setCurrentNode: buildGeneralSetState('currentNode'),
        setRoot: buildGeneralSetState('root'),
        setSgf: buildGeneralSetState('sgf'),
        setMat: buildGeneralSetState('mat'),
        setMarkup: buildGeneralSetState('markup'),
        setVisibleAreaMat: buildGeneralSetState('visibleAreaMat'),
        setCurrentMarkupText: buildGeneralSetState('currentMarkupText'),
        setCompressedPath: buildGeneralSetState('compressedPath'),
        setPath: buildGeneralSetState('path'),
        setActiveBranchIndexes: buildGeneralSetState('activeBranchIndexes'),
        setHighlights: buildGeneralSetState('highlights'),
        resetHightlight: buildGeneralResetState('highlights', []),
        forceUpdate: (state: Draft<BoardState>) => {
            state.update++;
        },
        reset: (state: Draft<BoardState>) => {
            state.reset++;
        },
    },
});
